import { createContext, type Dispatch, type SetStateAction } from 'react'

interface INavigationContext {
  setIsOpen: Dispatch<SetStateAction<boolean>>
  isOpen: boolean
}

export const initialContext: INavigationContext = {
  setIsOpen: () => {
    /* empty */
  },
  isOpen: false
}

export const NavigationContext = createContext<INavigationContext>(initialContext)
NavigationContext.displayName = 'NavigationContext'
